<template>
  <div class="questionDetail userAgreement modelPage">
    <navbar :nav="nav"></navbar>
    <div class="contentText">
      <div v-html="content"></div>
    </div>
  </div>
</template>

<script>
import { helpDetail } from "@/http/user";
import navbar from "../../components/navbar/index.vue";
export default {
  components: {
    navbar
  },
  data() {
    return {
      nav: {
        back: true,
        title: "",
        chat: false
      },
      content: ""
    };
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      helpDetail({ id: this.$route.query.id }).then(res => {
        let { data, code } = res.data;
        if (code == 200) {
          this.nav.title = data.title;
          this.content = data.content;
        }
      });
    }
  }
};
</script>

<style src="@/assets/css/mycenter.css" scoped></style>
<style>
.questionDetail.modelPage .contentText p {
  padding: 0;
  margin: 0;
}
.questionDetail.modelPage .contentText {
  /* padding-top: 10px; */
}
.questionDetail.modelPage .contentText img {
  max-width: 100%;
}
@media screen and (min-width: 1439px) {
  .questionDetail.modelPage .contentText {
    padding-top: 20px; /* no*/
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/model/questionDetail.vue